import { Routes as ReactRoutes, Route } from 'react-router'
import HomePage from '../../pages/HomePage'
import LeadFormsPage from '../../pages/LeadFormsPage'
import LeadFormBuilderPage from '../../pages/LeadFormBuilderPage'
import LeadFormResponsesPage from '../../pages/LeadFormResponsesPage'
import PublicFormPage from '../../pages/PublicFormPage'
import ContactsPage from '../../pages/ContactsPage'
import ContactDetailPage from '../../pages/ContactDetailPage'
import AccountsPage from '../../pages/AccountsPage'
import SalesPage from '../../pages/SalesPage'
import SalesCustomerRetentionPage from '../../pages/SalesCustomerRetentionPage'
import CustomerVerificationList from '../../pages/CustomerVerificationList'
import OrderVerificationList from '../../pages/OrderVerificationList'
import ServicePage from '../../pages/ServicePage'
import MarketingPage from '../../pages/MarketingPage'
import SettingsPage from '../../pages/SettingsPage'
import NotFoundPage from '../../pages/NotFoundPage'
import RolesPage from '../../pages/admin/RolesPage'
import RoleEditPage from '../../pages/admin/RoleEditPage'
import UsersPage from '../../pages/admin/UsersPage'
import ProfilePage from '../../pages/ProfilePage'
import ProtectedRoute from '../../features/auth/ProtectedRoute'
import CustomersPage from '../../pages/CustomersPage'
import CustomerDetailPage from '../../pages/CustomerDetailPage'
import LeadsPage from '../../pages/LeadsPage'
import LeadDetailPage from '../../pages/LeadDetailPage'
import TagsPage from '../../pages/TagsPage'
import TasksPage from '../../pages/TasksPage'
import WorkflowsPage from '../../pages/WorkflowsPage'
import DealsPage from '../../pages/DealsPage'
import DealDetailPage from '../../pages/DealDetailPage'
import SalesDetailPage from '../../pages/SalesDetailPage'
import SalesCustomerRetentionDetailPage from '../../pages/SalesCustomerRetentionDetailPage'
import PipelineStagesPage from '../../pages/PipelineStagesPage'
import SalesStagesPage from '../../pages/SalesStagesPage'
import TenantAdminPage from '../../pages/admin/TenantAdminPage'
import CalendarPage from '../../pages/CalendarPage'
import ActivityPage from '../../pages/ActivityPage'
import NotificationsPage from '../../pages/NotificationsPage'
import ChannelsPage from '../../pages/ChannelsPage'
import ChannelDetailPage from '../../pages/ChannelDetailPage'
import EmailFilesPage from '../../pages/EmailFilesPage'
import CustomerVerificationDetails from '../../pages/CustomerVerificationDetails'
import OrderVerificationDetails from '../../pages/OrderVerificationDetails'
import SalesExpirySettings from '../../pages/SalesExpirySettings'
import KnowlaritySettingsPage from '../../pages/KnowlaritySettingsPage'
import RecentOrdersPage from '../../pages/RecentOrdersPage'
import RecentOrderDetailPage from '../../pages/RecentOrderDetailPage'

export default function Routes() {
  return (
    <ReactRoutes>
      {/* All routes are protected — Keycloak handles unauthenticated redirects */}
      <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/contacts" element={<ProtectedRoute><ContactsPage /></ProtectedRoute>} />
      <Route path="/contacts/:id" element={<ProtectedRoute><ContactDetailPage /></ProtectedRoute>} />
      <Route path="/accounts" element={<ProtectedRoute><AccountsPage /></ProtectedRoute>} />
      <Route path="/sales" element={<ProtectedRoute><SalesPage /></ProtectedRoute>} />
      <Route path="/sales/leads" element={<ProtectedRoute><SalesPage /></ProtectedRoute>} />
      <Route path="/sales/leads/:id" element={<ProtectedRoute><LeadDetailPage /></ProtectedRoute>} />
      <Route path="/sales/:id" element={<ProtectedRoute><SalesDetailPage /></ProtectedRoute>} />
      <Route path="/customer-retention" element={<ProtectedRoute><SalesCustomerRetentionPage /></ProtectedRoute>} />
      <Route path="/customer-retention/:id" element={<ProtectedRoute><SalesCustomerRetentionDetailPage /></ProtectedRoute>} />
      <Route path="/recency-orders" element={<ProtectedRoute><RecentOrdersPage /></ProtectedRoute>} />
      <Route path="/recency-orders/:id" element={<ProtectedRoute><RecentOrderDetailPage /></ProtectedRoute>} />
      <Route path="/customer-verification" element={<ProtectedRoute><CustomerVerificationList /></ProtectedRoute>} />
      <Route path="/customer-verification/:id" element={<ProtectedRoute><CustomerVerificationDetails /></ProtectedRoute>} />
      <Route path="/order-verification" element={<ProtectedRoute><OrderVerificationList /></ProtectedRoute>} />
      <Route path="/order-verification/:id" element={<ProtectedRoute><OrderVerificationDetails /></ProtectedRoute>} />
      <Route path="/sales/opportunities" element={<ProtectedRoute><SalesPage /></ProtectedRoute>} />
      <Route path="/service" element={<ProtectedRoute><ServicePage /></ProtectedRoute>} />
      <Route path="/service/cases" element={<ProtectedRoute><ServicePage /></ProtectedRoute>} />
      <Route path="/service/cases/:id" element={<ProtectedRoute><ServicePage /></ProtectedRoute>} />
      <Route path="/marketing" element={<ProtectedRoute><MarketingPage /></ProtectedRoute>} />
      {/* Custom Forms — accessible from both /custom-forms and legacy /marketing/lead-forms */}
      <Route path="/custom-forms" element={<ProtectedRoute><LeadFormsPage /></ProtectedRoute>} />
      <Route path="/custom-forms/new" element={<ProtectedRoute><LeadFormBuilderPage /></ProtectedRoute>} />
      <Route path="/custom-forms/:id/edit" element={<ProtectedRoute><LeadFormBuilderPage /></ProtectedRoute>} />
      <Route path="/custom-forms/:id/responses" element={<ProtectedRoute><LeadFormResponsesPage /></ProtectedRoute>} />
      {/* Legacy routes kept for backward-compat */}
      <Route path="/marketing/lead-forms" element={<ProtectedRoute><LeadFormsPage /></ProtectedRoute>} />
      <Route path="/marketing/lead-forms/new" element={<ProtectedRoute><LeadFormBuilderPage /></ProtectedRoute>} />
      <Route path="/marketing/lead-forms/:id/edit" element={<ProtectedRoute><LeadFormBuilderPage /></ProtectedRoute>} />
      <Route path="/marketing/lead-forms/:id/responses" element={<ProtectedRoute><LeadFormResponsesPage /></ProtectedRoute>} />
      {/* Public form — no auth required */}
      {/* :slug is the real DB slug; optional /*  is the cosmetic company segment */}
      <Route path="/forms/:slug/*" element={<PublicFormPage />} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      {/* <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} /> */}
      <Route path="/customers" element={<ProtectedRoute><CustomersPage /></ProtectedRoute>} />
      <Route path="/customers/:id" element={<ProtectedRoute><CustomerDetailPage /></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
      <Route path="/leads/:id" element={<ProtectedRoute><LeadDetailPage /></ProtectedRoute>} />
      <Route path="/settings/tag" element={<ProtectedRoute><TagsPage /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
      <Route path="/workflows" element={<ProtectedRoute><WorkflowsPage /></ProtectedRoute>} />
      <Route path="/deals" element={<ProtectedRoute><DealsPage /></ProtectedRoute>} />
      <Route path="/deals/:id" element={<ProtectedRoute><DealDetailPage /></ProtectedRoute>} />
      <Route path="/settings/pipeline-stages" element={<ProtectedRoute><PipelineStagesPage /></ProtectedRoute>} />
      <Route path="/settings/sales-stages" element={<ProtectedRoute><SalesStagesPage /></ProtectedRoute>} />
      <Route path="/settings/sales-expiry" element={<ProtectedRoute><SalesExpirySettings /></ProtectedRoute>} />
      <Route path="/settings/knowlarity" element={<ProtectedRoute><KnowlaritySettingsPage /></ProtectedRoute>} />
      <Route path="/settings/email-files" element={<ProtectedRoute><EmailFilesPage /></ProtectedRoute>} />
      <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
      <Route path="/activity" element={<ProtectedRoute><ActivityPage /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
      <Route path="/channels" element={<ProtectedRoute><ChannelsPage /></ProtectedRoute>} />
      <Route path="/channels/:id" element={<ProtectedRoute><ChannelDetailPage /></ProtectedRoute>} />
      {/* Admin routes */}
      <Route path="/admin/roles" element={<ProtectedRoute><RolesPage /></ProtectedRoute>} />
      <Route path="/admin/roles/:id" element={<ProtectedRoute><RoleEditPage /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
      <Route path="/admin/tenants" element={<ProtectedRoute><TenantAdminPage /></ProtectedRoute>} />
      <Route path="*" element={<NotFoundPage />} />
    </ReactRoutes>
  )
}

